export default {
	name:'selectBox',
	props:{ //验证
		data:{ //筛选数据
			default(){
				return []
			}
		},
		dataId:{ //选中值
			type:String,
			default(){
				return ''
			}
		}
	},
	data(){
		return{

		}
	},
	watch:{
		dataId:{
			deep:true,
			immediate:true,
			handler(val){
				if(!val){
					this.data.value = '';
				}else{
					this.data.list.map(item=>{
						if(item.itemCode==val){
							this.data.value = item.itemCode;
						}
					})
				}
			}
		}
	},
	created(){
	},
	methods:{
		changeSelect(item){ //筛选-btn
			if(this.data.value != item.itemCode){
				this.data.value = item.itemCode;
				this.$emit('change',this.data);
			}
		},
	}
}
